import { useMutation, useQuery } from "@tanstack/react-query";
import axios from "axios";
import helpers from "helpers/index";
import queryClient, { IQueryParams } from 'queries';
/**
 * Các sự kiện làm thay đổi nội dung hoặc trạng thái của một trip manifest.
 *
 * Tên event mô tả nghiệp vụ đã xảy ra, không mô tả câu lệnh database
 * (CREATE/UPDATE/DELETE). Một nghiệp vụ có thể cập nhật nhiều bảng nhưng chỉ
 * nên tạo một event tương ứng trong timeline của chuyến.
 */
export enum ENUM_TRIP_MANIFEST_LOG_EVENT_TYPE {
    /** Vòng đời chuyến */
    MANIFEST_CREATED = 'MANIFEST_CREATED',
    MANIFEST_UPDATED = 'MANIFEST_UPDATED',
    MANIFEST_STATUS_CHANGED = 'MANIFEST_STATUS_CHANGED',
    MANIFEST_CANCELLED = 'MANIFEST_CANCELLED',
    MANIFEST_DELETED = 'MANIFEST_DELETED',

    /** Cấu hình và phân công chuyến */
    VEHICLE_CHANGED = 'VEHICLE_CHANGED',
    DEPARTURE_TIME_CHANGED = 'DEPARTURE_TIME_CHANGED',
    SEATING_TEMPLATE_CHANGED = 'SEATING_TEMPLATE_CHANGED',
    BONUS_CHANGED = 'BONUS_CHANGED',
    DRIVER_ASSIGNED = 'DRIVER_ASSIGNED',
    DRIVER_REMOVED = 'DRIVER_REMOVED',
    DRIVER_ROLE_CHANGED = 'DRIVER_ROLE_CHANGED',

    /** Vé ra/vào và thay đổi vị trí trong chuyến */
    TICKET_ASSIGNED = 'TICKET_ASSIGNED',
    TICKET_UNASSIGNED = 'TICKET_UNASSIGNED',
    TICKET_MOVED_IN = 'TICKET_MOVED_IN',
    TICKET_MOVED_OUT = 'TICKET_MOVED_OUT',
    TICKET_SEAT_CHANGED = 'TICKET_SEAT_CHANGED',
    TICKET_UPDATED = 'TICKET_UPDATED',
    TICKET_TEMPORARILY_DELETED = 'TICKET_TEMPORARILY_DELETED',
    TICKET_RESTORED = 'TICKET_RESTORED',
    TICKET_PERMANENTLY_DELETED = 'TICKET_PERMANENTLY_DELETED',
    TICKET_CLONED = 'TICKET_CLONED',
    TICKET_DETACHED = 'TICKET_DETACHED',
    TICKET_PRIORITY_CHANGED = 'TICKET_PRIORITY_CHANGED',

    /** Thay đổi đơn hàng đang nằm trong chuyến */
    ORDER_ADDED = 'ORDER_ADDED',
    ORDER_UPDATED = 'ORDER_UPDATED',
    ORDER_STATUS_CHANGED = 'ORDER_STATUS_CHANGED',
    ORDER_CANCELLED = 'ORDER_CANCELLED',
    ORDER_REMOVED = 'ORDER_REMOVED',
    ORDER_CALL_STATUS_CHANGED = 'ORDER_CALL_STATUS_CHANGED',
    ORDER_PICKUP_ASSIGNEE_CHANGED = 'ORDER_PICKUP_ASSIGNEE_CHANGED',
    ORDER_DROPOFF_ASSIGNEE_CHANGED = 'ORDER_DROPOFF_ASSIGNEE_CHANGED',
    ORDER_PICKUP_SEQUENCE_CHANGED = 'ORDER_PICKUP_SEQUENCE_CHANGED',
    ORDER_DROPOFF_SEQUENCE_CHANGED = 'ORDER_DROPOFF_SEQUENCE_CHANGED',

    /** Tiền và chi phí tác động tới chuyến */
    TRIP_FEE_ADDED = 'TRIP_FEE_ADDED',
    TRIP_FEE_REMOVED = 'TRIP_FEE_REMOVED',
    ORDER_PAYMENT_RECEIVED = 'ORDER_PAYMENT_RECEIVED',
    ORDER_PAYMENT_REFUNDED = 'ORDER_PAYMENT_REFUNDED',

    /** Các số tổng hợp được hệ thống tính lại từ vé, đơn hàng và chi phí */
    MANIFEST_TOTALS_RECALCULATED = 'MANIFEST_TOTALS_RECALCULATED',
}

/**
 *   Interface/model file auto generate for Trip_manifest_log
 *   Interface for back-end
 *   Model for front-end.
 *   They are the same!
 */


export interface TypedTrip_manifest_log {
    trip_manifest_log_id?: string;
    trip_manifest_id?: string;

    event_type?: ENUM_TRIP_MANIFEST_LOG_EVENT_TYPE;

    /** Ví dụ: NGuyễn Thanh đã thay đổi: Vé XXXXXX đã xóa bỏ khỏi chuyến */
    event_description?: string;

    /** Timestamp bigint ... */
    createdAt?: string;
}



/** Hiển thị tại trang chủ, hiển thị trực quan theo ngày thôi ... */
export function useGetTrip_manifests_log(trip_manifest_id: string) {
    return useQuery({
        queryKey: ["trip_manifest_log/fetch_entity_list", trip_manifest_id],
        queryFn: () => axios.get<TypedTrip_manifest_log[]>(`/trip_manifest_log/${trip_manifest_id}`).then(response => response.data),
        enabled: !!trip_manifest_id
    });
}


